import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Subtract"
      d="M7.34931 5.45664L2.69443 0.801758H18.1982V16.3055L13.5433 11.6506L6.99576 18.1982L0.801758 12.0042L7.34931 5.45664Z"
      fill="#222A5C"
    />
  </svg>,
  "ExportFilled"
);
